import { strings } from "@/constants";
import type { InvitationType } from "@/types";

import { InvitationRow } from "./invitation-row";

export const InvitationsList = ({
    invitations,
    isCancelling,
    isLoading,
    onCancel,
}: {
    invitations: InvitationType[],
    isCancelling: boolean,
    isLoading: boolean,
    onCancel: (id: number) => void,
}) => (
    <div
        className="
            overflow-hidden
            rounded-default
            border
            border-gray-200
            bg-surface
            shadow-sm
        "
    >
        {isLoading ? (
            <div
                className="
                    px-6
                    py-12
                    text-center
                    text-sm
                    text-text-secondary
                "
            >
                {strings.admin.loading}
            </div>
        ) : invitations.length === 0 ? (
            <div
                className="
                    px-6
                    py-12
                    text-center
                    text-sm
                    text-text-secondary
                "
            >
                {strings.admin.emptyInvitations}
            </div>
        ) : (
            <ul className="divide-y divide-gray-100">
                {invitations.map((invitation) => (
                    <InvitationRow
                        invitation={invitation}
                        isCancelling={isCancelling}
                        key={invitation.id}
                        onCancel={onCancel}
                    />
                ))}
            </ul>
        )}
    </div>
);
